import React, { useEffect, useState } from "react";
import s from "./SecondStepper.module.css";
//Servicios
import providersService from "../../../../../../api/providers/providersService";
import deliveryServices from "../../../../../../api/delivery/DeliveryService";
//assets
import CuponesModal from "../../Steppers/Modales/Cupones/CuponesModal";
import ProductosModal from "../../../../../Shared/ProductosModal";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
// Material UI
import Grid from "@mui/material/Grid"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableHead from "@mui/material/TableHead"
import TableBody from "@mui/material/TableBody"
import TableRow from "@mui/material/TableRow"
import TableCell from "@mui/material/TableCell"
import Button from "@mui/material/Button"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import CircularProgress from "@mui/material/CircularProgress"
import TextField from "@mui/material/TextField"
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import useTranslationException from "../../../../../../helpers/exceptions";
import Swal from "sweetalert2";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { today } from "../../../../../../helpers/today";

const SecondStepper = ({
  form,
  setForm,
  edit,
  raffles,
  setRaffles,
  passingType,
  order,
  destino,
}) => {
  const showExpetion = useTranslationException();

  const { language } = useSelector((state) => state.local);

  const allGameOffersActive = useSelector(
    (state) => state.gamma?.allGameOffersActive,
  );
  const { textColor } = useSelector((state) => state.local);
  const dispatch = useDispatch();

  //Estados
  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingDetailDelete, setLoadingDetailDelete] = useState(0);

  const [providerGames, setProviderGames] = useState([]);

  const [errorCouponsAmount, setErrorCouponsAmount] = useState({ error: false, message: "" })
  const [openDetail, setOpenDetail] = useState(false);
  const [newDetail, setNewDetail] = useState({
    amount: 0,
    nroCouponFrom: 0,
    nroCouponTo: 0,
    gameId: 0,
    raffleId: 0,
  });

  const [raffleSelected, setRaffleSelected] = useState(null);
  const [selectedGame, setSelectedGame] = useState(null);
  const [type, setType] = useState("default");
  const [openModal, setOpenModal] = useState(false);

  const [limitsByOrder, setLimitsByOrder] = useState([]);

  const [detailByOrder, setDetailByOrder] = useState(0);

  useEffect(() => {
    if (
      edit.status &&
      form.type === "Entrada" &&
      form.supplierId &&
      form.orderId
    ) {
      deliveryServices
        .getDeliveryNoteByOrderId(form?.orderId)
        .then((response) => {
          let orderLimit = order?.detailOrdersList?.map((item) => ({
            raffle: item?.raffle?.id,
            amount: item?.amount,
          }));
          let amountExist = {};
          response.forEach((obj) => {
            obj.detailList.forEach((detail) => {
              const raffle = detail.raffleReadDTO?.id;
              const amount = detail.amount;
              if (amountExist.hasOwnProperty(raffle)) {
                amountExist[raffle] += amount;
              } else {
                amountExist[raffle] = amount;
              }
            });
          });

          let limits = orderLimit.map((item) => {
            return {
              ...item,
              amount: amountExist[item.raffle]
                ? item.amount - amountExist[item.raffle]
                : item.amount,
            };
          });
          setLimitsByOrder(limits);
        });
    }
  }, [form?.orderId]);

  useEffect(() => {
    if (form.supplierId) {
      setLoading(true);
      providersService
        .getGamesProvider(form.supplierId, dispatch)
        .then((res) => setProviderGames(res.gamesIds))
        .then(() => setLoading(false))
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
        });
    }
  }, [form.supplierId]);

  useEffect(() => {
    if (newDetail.nroCouponFrom && newDetail.nroCouponTo) {
      const amount = newDetail.nroCouponTo - newDetail.nroCouponFrom + 1;
      setNewDetail({
        ...newDetail,
        amount
      })
    } else {
      setNewDetail({ ...newDetail, amount: 0 });
    }
  }, [newDetail]);

  useEffect(() => {
    if (newDetail.gameId) {
      let data = allGameOffersActive?.find(
        (i) => i.modality?.game?.id === newDetail.gameId,
      );
      if (data) {
        setType(data.modality?.mode?.name);
        setSelectedGame(data.modality);
      } else {
        setType("default");
        setSelectedGame({});
      }
    } else {
      setType("default");
      setSelectedGame({});
    }
  }, [newDetail.gameId]);

  useEffect(() => {
    if (detailByOrder) {
      let detail = order?.detailOrdersList?.find(
        (item) => item?.id === detailByOrder,
      );
      setNewDetail((prev) => ({
        ...prev,
        gameId: detail?.game?.id,
        raffleId: detail?.raffle?.id,
      }));
      setRaffleSelected(detail?.raffle);
    } else {
      setNewDetail((prev) => ({ ...prev, gameId: 0, raffleId: 0 }));
      setRaffleSelected(null);
    }
  }, [detailByOrder]);

  const validateNewDetail = () => {
    for (let i = 0; i < form.detailList.length; i++) {
      let item = form.detailList[i];
      if (
        !(
          (newDetail.nroCouponFrom < item.nroCouponFrom &&
            newDetail.nroCouponTo < item.nroCouponFrom) ||
          (newDetail.nroCouponFrom > item.nroCouponTo &&
            newDetail.nroCouponTo > item.nroCouponTo)
        ) &&
        newDetail.raffleId === item.raffleReadDTO.id
      ) {
        return false;
      }
    }
    return true;
  };

  const handleSubmitDetail = () => {
    const encontrado = form?.detailList.find(e => e.gameId === newDetail.gameId && e.raffleId === newDetail.raffleId && (newDetail.nroCouponFrom >= e.nroCouponFrom && newDetail.nroCouponFrom <= e.nroCouponTo) || (newDetail.nroCouponTo >= e.nroCouponFrom && newDetail.nroCouponTo <= e.nroCouponTo));

    if (encontrado) {
      Swal.fire({
        icon: "error",
        title: "Lo siento...",
        text: "El número de cupón desde o el número de cupón hasta esta dentro de un rango ya ingresado",
      });
    }
    else {
      setForm((prev) => {
        return {
          ...prev,
          detailList: [...prev.detailList, newDetail],
        };
      });
      setDetailByOrder(0);
      setLoadingDetail(false);
      setOpenDetail(false);
      setRaffleSelected(null);
      setLoadingDetail(true);
      setLoadingDetail(false);
    }
  };

  const handleDeleteDetail = (item) => {
    setLoadingDetailDelete(item?.id);

    setForm((prev) => {
      const updatedDetailList = prev.detailList.filter(
        (data) => data !== item
      );

      return {
        ...prev,
        detailList: updatedDetailList,
      };
    });

    const filterRaffles = raffles.filter(
      (r) => r?.raffleReadDTO?.id !== item.raffleId
    );
    setRaffles(filterRaffles);
    setLoadingDetailDelete(0);
  };

  useEffect(() => {
    setTimeout(() => {
      if (newDetail.amount) {
        const isValidAmount = newDetail.amount % raffleSelected?.couponsAmountPerBundle !== 0 ? false : true;
        const isInstant = raffleSelected?.game?.instant;

        if (!isValidAmount && isInstant) {
          setErrorCouponsAmount({
            error: true,
            message: `⚠ El número de cupones debe ser un múltiplo exacto de la cantidad de cupones por paquete (${raffleSelected.couponsAmountPerBundle}).`
          })
        } else if (newDetail.amount > 50000 && !isInstant) {
          setErrorCouponsAmount({
            error: true,
            message: `⚠ La cantidad de cupones supera el máximo permitido (50000 cupones).`
          })
        } else {
          setErrorCouponsAmount((prev) => ({ ...prev, error: false }))
        }
      }
    }, [1000])
  }, [raffleSelected?.couponsAmountPerBundle, raffleSelected?.game?.instant, newDetail.amount])

  function validateRanges() {
    if (form.orderId) {
      //Control si el remito tiene orden de pedido (Entrada de proveedor con Orden);
      return (
        newDetail.amount <= 0 ||
        newDetail.amount >
        limitsByOrder.find((item) => item.raffle === raffleSelected?.id)
          ?.amount
      );
    } else if (form.type === "Entrada" && !form?.supplierId) {
      //Control si el remito es proveniente de agencia (Entrada de agencia)
      return (
        newDetail.amount <= 0 ||
        newDetail.nroCouponFrom < raffleSelected.nroCouponFrom ||
        newDetail.nroCouponTo > raffleSelected.nroCouponTo
      );
    } else {
      //Todo el resto
      return newDetail.amount <= 0;
    }
  };
  // Section: JSX
  return (
    <Grid
      item
      container
      xs={12}
      className={s.container}
      sx={{ mb: 5 }}
      id="top"
    >
      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        className={s.init2}
      >
        <h4
          style={{
            fontSize: "1.6rem",
            fontWeight: 300,
            margin: 0,
            marginTop: "10px",
          }}
        >
          {t("details")}
        </h4>
      </Grid>
      {!form.agencyId &&
        !providerGames?.filter((g) =>
          allGameOffersActive?.find((i) => i.modality?.game?.id === g),
        ).length ? (
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "150px",
            fontSize: "1.3rem",
            fontWeight: 300,
          }}
          className={s.init2}
        >
          {loading ? <CircularProgress /> : t("providerNoActiveGames")}
        </Grid>
      ) : (
        <>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className={s.init}
          >
            {form.detailList?.length ? (
              <TableContainer className={s.tableContainer} sx={{ my: 4 }}>
                <Table>
                  <TableHead sx={{ backgroundColor: "primary.main" }}>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontSize: ".9rem",
                          fontWeight: 500,
                          color: textColor,
                        }}
                      >
                        {t("quantity")}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: ".9rem",
                          fontWeight: 500,
                          color: textColor,
                        }}
                      >{`${t("coupons")}`}</TableCell>
                      <TableCell
                        sx={{
                          fontSize: ".9rem",
                          fontWeight: 500,
                          color: textColor,
                        }}
                      >
                        {t("game")}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: ".9rem",
                          fontWeight: 500,
                          color: textColor,
                        }}
                      >
                        {t("drawNumber")}/{t("serie")}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: ".9rem",
                          fontWeight: 500,
                          color: textColor,
                        }}
                      ></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {form.detailList.map((item, i) => (
                      <React.Fragment key={i}>
                        {" "}
                        <TableRow>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {item.nroCouponTo - item.nroCouponFrom + 1}
                          </TableCell>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {item.nroCouponFrom}-{item.nroCouponTo}
                          </TableCell>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {allGameOffersActive?.find(
                              (i) => i.modality?.game?.id === item.gameId,
                            )
                              ? allGameOffersActive?.find(
                                (i) => i.modality?.game?.id === item.gameId,
                              ).modality.game.name
                              : "-"}
                          </TableCell>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {raffles[i]?.raffleReadDTO?.number ||
                              raffles[i]?.raffleReadDTO?.serie ||
                              "-"}
                          </TableCell>
                          <TableCell>
                            {loadingDetailDelete === item.id ? (
                              <CircularProgress color="primary" size="1.8rem" />
                            ) : (
                              <DeleteForeverRoundedIcon
                                sx={{
                                  color: "primary.main",
                                  fontSize: "1.8rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleDeleteDetail(item)}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px",
                }}
              >
                <h4 style={{ fontSize: "1.5rem", fontWeight: 300 }}>
                  {t("noItemsAdded")}
                </h4>
              </Grid>
            )}
          </Grid>

          <Grid item xs={11} sx={{ mb: 5 }}>
            <hr style={{ width: "100%" }} />
          </Grid>

          {openDetail ? (
            <Grid item container xs={12} id="add-form" className={s.init2} >
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}
              >
                <p
                  style={{ margin: 0, fontSize: "1.3rem", fontWeight: 400 }}
                >
                  {`${t("addDetail")}`}
                </p>
                {order?.id ? (
                  <p
                    style={{
                      margin: 0,
                      marginTop: ".3rem",
                      fontSize: "1rem",
                      fontWeight: 400,
                      opacity: 0.7,
                    }}
                  >
                    {`${t("detailsByOrder")}: ${order?.id?.toString().padStart(5, "0")}`}
                  </p>
                ) :
                  null
                }
                {order?.id ? (
                  raffleSelected ? (
                    <p
                      style={{
                        margin: 0,
                        marginTop: "1rem",
                        fontSize: "1.1rem",
                        fontWeight: 500,
                        opacity: 0.8,
                      }}
                    >{`${t("couponsLimit")}: ${limitsByOrder.find((item) => item.raffle === raffleSelected?.id)?.amount}`}</p>
                  ) : null
                ) : null}
                {form.type === "Entrada" &&
                  !form?.supplierId &&
                  raffleSelected ? (
                  <p
                    style={{
                      margin: 0,
                      marginTop: ".3rem",
                      fontSize: "1rem",
                      fontWeight: 400,
                      opacity: 0.7,
                    }}
                  >{`${t("couponsLimit")}: ${raffleSelected?.nroCouponFrom} ${t("to").toLowerCase()} ${raffleSelected?.nroCouponTo}`}</p>
                ) : null}
              </Grid>

              <Grid item xs={12} lg={6} sx={{ mt: 5 }}>
                {order?.id ? (
                  <FormControl sx={{ width: "97%" }}>
                    <InputLabel>{t("game")}</InputLabel>
                    <Select
                      label={t("game")}
                      value={detailByOrder}
                      onChange={(e) => setDetailByOrder(e.target.value)}
                    >
                      <MenuItem value={0} > {t("select")} </MenuItem>
                      {order?.detailOrdersList?.map((item) => (
                        <MenuItem
                          value={item?.id}
                        >
                          {`${item?.game?.name} - ${item?.raffle?.number ?
                            `${t("drawNumber")}: ${item?.raffle?.number}` :
                            item?.raffle?.serie ? `${t("serie")}: ${item?.raffle?.serie}` : ""}`
                          }
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : (
                  <FormControl sx={{ width: "97%" }}>
                    <InputLabel>{t("game")}</InputLabel>
                    <Select
                      label={t("game")}
                      value={newDetail.gameId}
                      onChange={(e) =>
                        setNewDetail((prev) => ({
                          ...prev,
                          gameId: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={0}>{t("select")}</MenuItem>
                      {!form.agencyId
                        ? providerGames?.map((g, i) =>
                          allGameOffersActive?.find(
                            (i) => i.modality?.game?.id === g,
                          ) ? (
                            <MenuItem key={i} value={g}>
                              {
                                allGameOffersActive?.find(
                                  (i) => i.modality?.game?.id === g,
                                )?.modality?.game?.name
                              }
                            </MenuItem>
                          ) : null,
                        )
                        : allGameOffersActive
                          ?.slice()
                          ?.sort((a, b) =>
                            a.modality.game.name.localeCompare(
                              b.modality.game.name,
                            ),
                          )
                          ?.map((g, i) => (
                            <MenuItem key={i} value={g?.modality?.game?.id}>
                              {g?.modality?.game?.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>

              <Grid container item xs={12} sx={{ mt: 3 }}>
              {newDetail.gameId && selectedGame?.mode?.name === "INSTANTANEO" && form.type === "Salida" ? (
                      !order?.id ? (
                        <Grid item container lg={12} mb={3} className={s.init}>
                          <Grid
                            item
                            lg={5.9}
                            xs={11}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                        adapterLocale={language}
                                      >
                                        <DatePicker
                                          label={t("settlementDate")}
                                          autoOk
                                          minDate={form.type === "Salida" ? today() : false}
                                          inputFormat="DD/MM/YYYY"
                                          inputProps={{
                                            readOnly: true,
                                          }}
                                          value={form.settlementDate}
                                          onChange={(e) =>
                                            setForm((prev)=>({ ...prev, settlementDate: new Date(e.toLocaleString()) }))
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} sx={{ width: "95%" }} />
                                          )}
                                        />
                             </LocalizationProvider>
                          </Grid>
                        </Grid>
                      ) : null
                    ) : null}
                {form.type === "Salida" ? (
                  newDetail.gameId ? (
                    <Grid item xs={12}>
                      <p
                        style={{
                          margin: 0,
                          marginBottom: "10px",
                          fontSize: "1.2rem",
                          fontWeight: 300,
                        }}
                      >
                        {t("coupons")}
                      </p>
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => setOpenModal(true)}
                      >
                        {t("searchStock")}
                      </Button>
                    </Grid>
                  ) : null
                ) : (
                  <Grid
                    item
                    container
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {newDetail.gameId ? (
                      !order?.id ? (
                        <Grid item container lg={12} mb={3} className={s.init}>
                          <Grid
                            item
                            lg={5.9}
                            xs={11}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            <TextField
                              value={
                                raffleSelected?.number ||
                                raffleSelected?.serie ||
                                t("selectProduct")
                              }
                              label={t("DrawAndNum")}
                              InputProps={{ readOnly: true }}
                              sx={{ cursor: "pointer", width: "75%" }}
                            />
                            <Button
                              sx={{ ml: 3 }}
                              variant="contained"
                              onClick={() => setOpenModal(true)}
                            >
                              {t("find")}
                            </Button>
                          </Grid>
                        </Grid>
                      ) : null
                    ) : null}
                    {raffleSelected?.id ? (
                      <>
                        <Grid item xs={12} lg={4} className={s.init} mb={3} >
                          <TextField
                            label={"Nro. Cupón Desde"}
                            sx={{ width: "95%" }}
                            value={newDetail.nroCouponFrom}
                            onChange={(e) => {
                              if (
                                !isNaN(e.target.value) &&
                                Number(e.target.value) >= 0
                              ) {
                                setNewDetail({
                                  ...newDetail,
                                  nroCouponFrom: Number(e.target.value),
                                });
                              }
                            }}
                            onKeyPress={(e) => {
                              if (e?.key === "-" || e?.key === "+") {
                                e.preventDefault();
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={4} className={s.init} mb={3}>
                          <TextField
                            name="coupon-to"
                            label={"Nro. Cupón Hasta"}
                            sx={{ width: "95%" }}
                            onChange={(e) => {
                              if (
                                !isNaN(e.target.value) &&
                                Number(e.target.value) >= 0
                              ) {
                                setNewDetail({
                                  ...newDetail,
                                  nroCouponTo: Number(e.target.value),
                                });
                              }
                            }}
                            onKeyPress={(e) => {
                              if (e?.key === "-" || e?.key === "+") {
                                e.preventDefault();
                              }
                            }}
                            value={newDetail.nroCouponTo}
                          />
                        </Grid>
                        <Grid item lg={4} xs={12}>
                          <p
                            style={{
                              fontSize: "1.8rem",
                              fontWeight: 300,
                              margin: 0,
                            }}
                          >
                            {validateRanges()
                              ? t("invalid")
                              : `${newDetail.amount} ${t("coupons")}`
                            }
                          </p>
                        </Grid>
                      </>
                    ) : null}
                  </Grid>
                )}
                {
                  errorCouponsAmount.error &&
                  <cap
                    className={s.input}
                  >
                    {errorCouponsAmount.message}
                  </cap>
                }
              </Grid>

              {form.type === "Entrada" ? (
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Button
                    variant="contained"
                    onClick={() => handleSubmitDetail()}
                    disabled={
                      loadingDetail ||
                      newDetail.gameId === 0 ||
                      newDetail.raffleId === 0 ||
                      newDetail.nroCouponFrom === 0 ||
                      newDetail.nroCouponTo === 0 ||
                      errorCouponsAmount.error ||
                      validateRanges()
                    }
                  >
                    {loadingDetail ? (
                      <CircularProgress size="1.5rem" />
                    ) : (
                      t("add")
                    )}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      window.scrollTo({ top: 40 });
                      setNewDetail({
                        amount: 0,
                        nroCouponFrom: "",
                        nroCouponTo: "",
                        gameId: 0,
                        raffleId: 0,
                      });
                      setDetailByOrder(0);
                      setOpenDetail(false);
                      setRaffleSelected(null);
                    }}
                    sx={{ ml: 2 }}
                  >
                    {t("cancel")}
                  </Button>
                </Grid>
              ) : null}
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                onClick={() => setOpenDetail(true)}
                href="#add-form"
              >
                {t("addDetail")}
              </Button>
            </Grid>
          )}
        </>
      )}
      {openModal ? (
        form.type !== "Salida" ? (
          <ProductosModal
            data={{
              number: form?.agencyId || form?.supplierId,
              type: form?.supplierId ? "proveedor" : "agency",
            }}
            game={selectedGame}
            open={openModal}
            setOpen={setOpenModal}
            setDetail={setNewDetail}
            selectProduct={setRaffleSelected}
          />
        ) : (
          <CuponesModal
            setRaffles={setRaffles}
            edit={edit}
            setFormulario={setForm}
            formulario={form}
            open={openModal}
            setOpen={setOpenModal}
            gameId={newDetail?.gameId}
            type={type}
            selectedGame={selectedGame?.game}
            passingType={passingType}
          />
        )
      ) : null}
    </Grid>
  );
};

export default SecondStepper;
